import PropTypes from 'prop-types';
import Button from "components/ui/Button/Button";
import BulletinCreateUpdate from "features/bulletins/components/BulletinCreateUpdate";
import { ReactComponent as IconPencil } from "assets/images/icons/pencil-square-primary.svg";
import BulletinDelete from "features/bulletins/components/BulletinDelete";
import { ReactComponent as IconTrash } from "assets/images/icons/trashfull.svg";
import { useDialog } from "context/DialogContext";

const BulletinOwnerButtons = ({ bulletinId, bulletinTitle, categoryId, isMarketPlace, onEdited, onDeleted }) => {
  const { showDialog } = useDialog();
  return (
    <>
      <Button variant={ 'ghost' }
              onClick={ () => showDialog(<BulletinCreateUpdate id={ bulletinId }
                                                               isMarketPlace={ isMarketPlace }
                                                               categoryId={ categoryId }
                                                               onCompleted={ onEdited }/>) }
              className={ 'button--small' }>
        <IconPencil/>
        Bericht bewerken
      </Button>

      <Button variant={ 'ghost' }
              onClick={ () => showDialog(<BulletinDelete id={ bulletinId }
                                                         title={ bulletinTitle }
                                                         onCompleted={ onDeleted }/>) }
              className={ 'button--small' }>
        <IconTrash/>
        Bericht verwijderen
      </Button>
    </>
  )
}

BulletinOwnerButtons.propTypes = {
  bulletinId: PropTypes.number.isRequired,
  bulletinTitle: PropTypes.string.isRequired,
  categoryId: PropTypes.number,
  isMarketPlace: PropTypes.bool,
  onDeleted: PropTypes.func.isRequired,
  onEdited: PropTypes.func.isRequired,
}

export default BulletinOwnerButtons;
